
export const DS_NO_ETH_WALLET = "DS_NO_ETH_WALLET";
export const DS_ETH_ACCOUNT_REQUEST_PENDING = "DS_ETH_ACCOUNT_REQUEST_PENDING";
export const DS_NO_ETH_ACCOUNT = "DS_NO_ETH_ACCOUNT";
export const DS_WRONG_ETH_NETWORK = "DS_WRONG_ETH_NETWORK";
